import { ErrorHandling } from "@serenity-is/corelib";

//window.addEventListener("unhandledrejection", ErrorHandling.unhandledRejectionHandler)
window.onerror = ErrorHandling.runtimeErrorHandler;
window.addEventListener('unhandledrejection', function (event) {
    // Verifica se la reason è un AbortError (tipico di fetch abortiti)
    if (event.reason && event.reason.name === 'AbortError') {
        // Qui puoi ignorare l'errore o loggarlo in modo silenzioso
        // Se vuoi evitare che il browser mostri l'errore in console:
        event.preventDefault();
        return;
    }

    // Gestione standard per altri tipi di errori
    // Ad esempio: mostrare una notifica o loggare l'errore
    // console.error('Unhandled promise rejection:', event.reason);
});


